import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isBetween from 'dayjs/plugin/isBetween';
import relativeTime from 'dayjs/plugin/relativeTime';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isoWeek from 'dayjs/plugin/isoWeek';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import getCurrentTimeZone from '@/helpers/getCurrentTimeZone';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isBetween);
dayjs.extend(relativeTime);
dayjs.extend(customParseFormat);
dayjs.extend(isoWeek);
dayjs.extend(quarterOfYear);
// consumers get dayjs.tz, which has no extend of its own, so every plugin lands here
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

window.addEventListener('storage', () => {
    dayjs.tz.setDefault(getCurrentTimeZone());
});
dayjs.tz.setDefault(getCurrentTimeZone());
dayjs.tz.unix = function(timestamp) {
    return dayjs.unix(timestamp).tz(getCurrentTimeZone());
};

export default dayjs.tz;